import React, {useState, useEffect} from "react";
import Button from "@mui/material/Button";
import {Outlet, Link, Navigate, withRouter, redirect,} from "react-router-dom";
import Appbar from "./Appbar";
import {Alert, CircularProgress, Snackbar} from "@mui/material";
import ErrorMsg from "./msg/ErrorMsg";
import axios from "axios";
import Admin_Dashboard from "./Admin_Dashboard";
const Homepage = ({isMobile}) => {
    const [isLogin, setIsLogin] = useState(false);
    const [loading, setLoading] = useState(false);
    const [createPishFactor, setCreatePishFactor] = useState(false);
    const [accessibility, setAccessibility] = useState("");
    const [factors, setFactors] = useState(false);
    const [orders, setOrders] = useState(false);
    useEffect(()=>{
        if (!!localStorage.getItem("token")){
            redirect()
        }
    },[])
    useEffect(() => {
        setLoading(true);
        const data = {
            token: localStorage.getItem("token"),
        }
        axios.post("https://app.zhivay.com/api/get_accessibility.php", data)
            .then(response => {
                setLoading(false);
                if (response.status === 200)
                    if (response.data.error === false) {
                        setAccessibility(response.data);
                    }
                    else {
                        if (response.data.error === true)
                            if (response.data.ex_token === true)
                                localStorage.clear();
                    }
            })
            .catch(error => {
                setLoading(false);
            })
    }, "");

    return (
        <>
            <div className="root" style={{width:!isMobile ? "calc(100% - 240px)" : ""}}>
                <Appbar isMobile={isMobile}/>
                {!loading ?
                    <div>
                        {accessibility.admindashboard === "1" ?
                            <Admin_Dashboard/>
                            : ''
                        }
                        {accessibility.employs === "1" ?
                            <Link to="/employslist">
                                <Button
                                    onClick={() => {
                                    }}
                                    variant="contained"
                                    sx={{
                                        padding: 2,
                                        width: '95%',
                                        fontFamily: 'farsi',
                                    }}>
                                    کارمندان
                                </Button>
                            </Link>
                            : ''
                        }
                        {accessibility.factors === "1" ?
                            <Link to="/factors">
                                <Button
                                    onClick={() => {
                                    }}
                                    variant="contained"
                                    sx={{
                                        marginTop: 5,
                                        padding: 2,
                                        width: '95%',
                                        fontFamily: 'farsi',
                                    }}>
                                    فاکتور
                                </Button>
                            </Link>
                            : ''}
                        {accessibility.orders === "1" ?
                            <Link to="/orders">
                                <Button
                                    onClick={() => {
                                    }}
                                    variant="contained"
                                    sx={{
                                        marginTop: 5,
                                        padding: 2,
                                        width: '95%',
                                        fontFamily: 'farsi',
                                    }}>
                                    سفارشات
                                </Button>
                            </Link>
                            : ''}
                    </div>
                    : <CircularProgress sx={{margin: 2}}/>}
            </div>
            <Outlet/>
        </>
    )
}

export default Homepage